<template>
  <div class="pa-0">
    <!-- Search and Actions -->
    <v-row class="mb-4 align-center px-4">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="search"
          label="Buscar unidad..."
          prepend-inner-icon="fas fa-search"
          outlined
          dense
          hide-details
          clearable
          class="modern-search-field"
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-btn color="primary" depressed @click="create" class="px-6">
          <v-icon left small>fas fa-plus</v-icon> Nueva Unidad
        </v-btn>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card outlined class="modern-card elevation-0 overflow-hidden">
      <v-data-table
        :headers="headers"
        :items="units"
        :loading="loading"
        :search="search"
        sort-by="id"
        class="modern-table"
        :items-per-page="15"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 15, 30, 50]
        }"
      >
        <template v-slot:item.id="{ item }">
          <span class="caption grey--text font-weight-bold">#{{ item.id }}</span>
        </template>

        <template v-slot:item.name="{ item }">
          <span class="body-2 font-weight-bold primary--text">{{ item.name }}</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon small color="primary" @click.stop="edit(item)">
            <v-icon small>fas fa-edit</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal -->
    <v-dialog v-model="showDialog" max-width="500px" persistent>
      <v-card outlined class="modern-card overflow-hidden">
        <v-sheet color="grey lighten-4" class="px-6 py-4 border-bottom">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-3">
              {{ newUnit.id > 0 ? 'fas fa-edit' : 'fas fa-plus-circle' }}
            </v-icon>
            <div>
              <div class="text-h6 font-weight-bold lh-1">
                {{ newUnit.id > 0 ? 'Actualizar Unidad' : 'Nueva Unidad' }}
              </div>
              <div class="caption grey--text mt-1">Configuración de métricas de producción</div>
            </div>
          </div>
        </v-sheet>

        <v-card-text class="pa-6 pt-8">
          <ValidationObserver v-slot="{ handleSubmit }">
            <v-form @submit.prevent="handleSubmit(newUnit.id > 0 ? updateUnit : createUnit)">
              <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="newUnit.name"
                  label="Nombre de la Unidad"
                  placeholder="Ej: Metros, Kilos, Horas..."
                  outlined
                  dense
                  autofocus
                  hide-details="auto"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>

              <v-divider class="my-6"></v-divider>

              <div class="d-flex justify-end">
                <v-btn text small @click="showDialog = false" class="mr-2">Cancelar</v-btn>
                <v-btn type="submit" color="primary" depressed small class="px-6">
                  <v-icon x-small class="mr-2">fas fa-save</v-icon>
                  Guardar
                </v-btn>
              </div>
            </v-form>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { fetchUnits, createUnit, updateUnit } from '@/api/products'
import notifications from '@/utils/notifications'

export default {
  name: 'Unit',
  data: () => ({
    units: [],
    search: '',
    showDialog: false,
    loading: false,
    newUnit: { id: -1, name: '' },
    headers: [
      { text: 'ID', value: 'id', align: 'start', width: '80', class: 'grey lighten-4' },
      { text: 'Nombre de la Unidad', value: 'name', align: 'start', class: 'grey lighten-4' },
      { text: 'Acciones', value: 'actions', align: 'center', width: '100', sortable: false, class: 'grey lighten-4' }
    ],
  }),
  methods: {
    edit(item) {
      this.newUnit = { ...item }
      this.showDialog = true
    },
    create() {
      this.newUnit = { id: -1, name: '' }
      this.showDialog = true
    },
    async createUnit() {
      try {
        await createUnit(this.newUnit)
        notifications.showSuccess('Unidad creada correctamente')
        this.showDialog = false
        this.refresh()
      } catch (e) {
        notifications.showError('Error al crear unidad')
      }
    },
    async updateUnit() {
      try {
        await updateUnit(this.newUnit)
        notifications.showSuccess('Unidad actualizada')
        this.showDialog = false
        this.refresh()
      } catch (e) {
        notifications.showError('Error al actualizar unidad')
      }
    },
    async refresh() {
      this.loading = true
      const res = await fetchUnits()
      this.units = res
      this.loading = false
    }
  },
  async created() {
    this.refresh()
  }
}
</script>

<style scoped>
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 12px !important;
}
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.08); }
.lh-1 { line-height: 1.2; }
</style>
